// extracted by mini-css-extract-plugin
module.exports = {"uploadModalStyle":"_1Yh1XAkOXx_3fYG54iMDPi"};